import React from "react";
import ListHisstoryContainer from "../../containers/History";

const HistoryScreen = () => {
  return <ListHisstoryContainer />;
};

export default HistoryScreen;
